import URL_MAP from './urls';

export const ACTIONS = {
  UPDATE: 'VIDEOSESSION_DATA_UPDATE',
  CLEAR: 'VIDEOSESSION_CLEAR',
};

export const STORAGE_VIDEOSESSION_NAMESPACE = 'local_videosession_data_space';

export const VIDEO_RECORD_TYPES = {
  VIDEO_RESUME: {
    type: 1,
    name: 'system.videoResume',
  },
  VIDEO_VACANCY: {
    type: 2,
    name: 'system.videoVacancy',
  },
  VIDEO_REVIEW: {
    type: 3,
    name: 'system.videoReview',
  },
  VIDEO_BUSINESS_CARD: {
    type: 4,
    name: 'system.videoBusinessCard',
  },
  VIDEO_CONVERSATION: {
    type: 5,
    name: 'system.videoConversation',
  },
};

export const VIDEO_RECORD_TITLE = {
  VIDEO_RESUME: 'videoSessionTitle.resume',
  VIDEO_VACANCY: 'videoSessionTitle.vacancy',
  VIDEO_BUSINESS_CARD: 'videoSessionTitle.businessCard',
  VIDEO_SESSION: 'videoSessionTitle.session',
};

export const MY_VIDEO_RECORD_TITLE = {
  VIDEO_RESUME: 'videoRecordsTitle.resume',
  VIDEO_VACANCY: 'videoRecordsTitle.vacancy',
  VIDEO_BUSINESS_CARD: 'videoRecordsTitle.businessCard',
  VIDEO_SESSION: 'videoRecordsTitle.session',
};

export function getMyRecordTitleByRoute(route) {
  switch (route) {
  case URL_MAP.VIDEO_RESUME: return 'videoRecordsTitle.resume';
  case URL_MAP.VIDEO_VACANCY: return 'videoRecordsTitle.vacancy';
  case URL_MAP.VIDEO_BUSINESS_CARD: return 'videoRecordsTitle.businessCard';
  default: return 'videoRecordsTitle.session';
  }
}

export function getMyRecordRouteByUrl(route) {
  switch (route) {
  case URL_MAP.VIDEO_RESUME: return URL_MAP.MY_VIDEO_RESUME;
  case URL_MAP.VIDEO_VACANCY: return URL_MAP.MY_VIDEO_VACANCY;
  case URL_MAP.VIDEO_BUSINESS_CARD: return URL_MAP.MY_VIDEO_BUSINESS_CARD;
  default: return URL_MAP.MY_VIDEO_SESSION;
  }
}

export const VIDEO_RECORD_TYPE_OPTIONS = [
  {
    value: VIDEO_RECORD_TYPES.VIDEO_RESUME.type,
    label: VIDEO_RECORD_TYPES.VIDEO_RESUME.name,
  },
  {
    value: VIDEO_RECORD_TYPES.VIDEO_VACANCY.type,
    label: VIDEO_RECORD_TYPES.VIDEO_VACANCY.name,
  },
  {
    value: VIDEO_RECORD_TYPES.VIDEO_REVIEW.type,
    label: VIDEO_RECORD_TYPES.VIDEO_REVIEW.name,
  },
  {
    value: VIDEO_RECORD_TYPES.VIDEO_BUSINESS_CARD.type,
    label: VIDEO_RECORD_TYPES.VIDEO_BUSINESS_CARD.name,
  },
  {
    value: VIDEO_RECORD_TYPES.VIDEO_CONVERSATION.type,
    label: VIDEO_RECORD_TYPES.VIDEO_CONVERSATION.name,
  },
];

export function getVideoRecordNameByType(videoRecordType) {
  switch (videoRecordType) {
  case VIDEO_RECORD_TYPES.VIDEO_RESUME.type: return VIDEO_RECORD_TYPES.VIDEO_RESUME.name;
  case VIDEO_RECORD_TYPES.VIDEO_VACANCY.type: return VIDEO_RECORD_TYPES.VIDEO_VACANCY.name;
  case VIDEO_RECORD_TYPES.VIDEO_REVIEW.type: return VIDEO_RECORD_TYPES.VIDEO_REVIEW.name;
  case VIDEO_RECORD_TYPES.VIDEO_BUSINESS_CARD.type: return VIDEO_RECORD_TYPES.VIDEO_BUSINESS_CARD.name;
  case VIDEO_RECORD_TYPES.VIDEO_CONVERSATION.type: return VIDEO_RECORD_TYPES.VIDEO_CONVERSATION.name;
  default: return '';
  }
}
